import { combineReducers } from 'redux';

import { activeFeatureReducer } from './activeFeature';
import { detailsVisiblePrecisionReducer } from './detailsVisiblePrecision';
import { featuresReducer } from './features';
import { frecklesReducer } from './freckles';
import { infrastructureReducer } from './infrastructure';
import { isDrawingModeReducer } from './isDrawingMode';
import { isFirstMapInteractionReducer } from './isFirstMapInteraction';
import { isRulerEnabledReducer } from './isRulerEnabled';
import { mapBoundsReducer } from './mapBounds';
import { TMapActions } from '../actions';
import { IMapInternalState } from '../types';

export {
  isFirstMapInteractionReducer,
  defaultState as isFirstMapInteractionDefaultState,
} from './isFirstMapInteraction';
export { isRulerEnabledReducer, defaultState as isRulerEnabledDefaultState } from './isRulerEnabled';
export { isDrawingModeReducer, defaultState as isDrawingModeDefaultState } from './isDrawingMode';
export { featuresReducer, defaultState as featuresDefaultState } from './features';
export { activeFeatureReducer, defaultState as activeFeatureDefaultState } from './activeFeature';
export { frecklesReducer, defaultState as frecklesDefaultState } from './freckles';
export * from './infrastructure';

export const mapReducer = combineReducers<IMapInternalState, TMapActions>({
  activeFeature: activeFeatureReducer,
  features: featuresReducer,
  freckles: frecklesReducer,
  detailsVisiblePrecision: detailsVisiblePrecisionReducer,
  infrastructure: infrastructureReducer,
  isFirstMapInteraction: isFirstMapInteractionReducer,
  isDrawingMode: isDrawingModeReducer,
  isRulerEnabled: isRulerEnabledReducer,
  mapBounds: mapBoundsReducer,
});
